export default "__VITE_ASSET__BM5OjLSx__"